// export default function AuthButton(props) {
//     return (
//         <button className="bg-[#00B0AD] py-3 shadow-md font-semibold text-white rounded-[4px] text-[14px]">
//             {props.title}
//         </button>
//     )
// }

import Spinner from "../spinners/Spinner";

export default function AuthButton(props) {
  return (
    <button
      disabled={props.disabled}
      onClick={props.onClick}
      type={props.type}
      className={`${
        props.disabled
          ? "cursor-not-allowed bg-primary-light text-primary"
          : "cursor-pointer bg-primary text-white"
      } w-full ${
        props.width ? "sm:w-full" : "sm:w-[350px]"
      } py-3 flex justify-center items-center shadow-md font-semibold rounded-[4px] text-[14px]`}
      style={props.style}
    >
      {props.isLoading ? <Spinner /> : props.title}
    </button>
  );
}
